import { render, staticRenderFns } from "./UsageChart.vue?vue&type=template&id=45a96b42&scoped=true&"
import script from "./UsageChart.vue?vue&type=script&lang=js&"
export * from "./UsageChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a96b42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a96b42')) {
      api.createRecord('45a96b42', component.options)
    } else {
      api.reload('45a96b42', component.options)
    }
    module.hot.accept("./UsageChart.vue?vue&type=template&id=45a96b42&scoped=true&", function () {
      api.rerender('45a96b42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/usage/usagedetailgraph/UsageChart.vue"
export default component.exports